"use client";

import { useEffect, useState } from "react";
import ReactGA from "react-ga4";

const CookieConsent: React.FC = () => {
  const [consentBoxVisible, setConsentBoxVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const cookieValue = document.cookie
      .split("; ")
      .find((row) => row.startsWith("cookieconsent="))
      ?.split("=")[1];

    if (cookieValue === "true") {
      initializeAnalytics();
    } else if (cookieValue !== "false") {
      setConsentBoxVisible(true);
    }
  }, []);

  const confirmAgreement = (option: boolean) => {
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 150);
    document.cookie = `cookieconsent=${option}; path=/; expires=${expiryDate.toUTCString()}`;

    setConsentBoxVisible(false);

    if (option) {
      initializeAnalytics();
    }
  };

  const initializeAnalytics = () => {
    if (!window.gtag) {
      ReactGA.initialize("G-DN5MBZ5W53"); // Use your actual Measurement ID
    }

    const page = window.location.pathname + window.location.search;
    ReactGA.send({ hitType: "pageview", page });
  };

  if (!consentBoxVisible) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
      tabIndex={-1}
      role="dialog"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Cookie Settings</h5>
          </div>
          <div className="modal-body">
            <p>
              By continuing to use the site, you agree to our use of cookies.
              ChaletAway values your privacy above all. We use essential cookies
              to keep things running smoothly, and optional ones to enhance your
              experience — helping you find the fastest route to perfect powder.
              Your consent is warmly welcomed, but entirely optional.
            </p>
            <p>
              Warm regards,
              <br />
              <strong>The CA Team</strong>
            </p>
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-primary"
              onClick={() => confirmAgreement(true)}
            >
              OK
            </button>
            {/* <button
              className="btn btn-secondary"
              onClick={() => confirmAgreement(false)}
            >
              Opt Out
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
